export function isForOwnersEmpty(props) {
    return !props || !props?.cards || !props?.cards.length;
}
